import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AuthContainer from "../../containers/Auth";
import { useNavigate } from "react-router-dom";
import { TokenContext } from "../../service/context/tokencontent";
import { validationSchema } from "../../service/validation/emailotp";
import CustomModal from "../../components/Modal";
import { AUTH_URL } from "../../common/common";
import OtpInput from "../../components/OTP";
import { ApiService } from "../../service/api.service";
import { check, verificationbadge } from "../../common/svg";
import SecureImage from "../../components/BucketImage/Image";

const OTPVerification = () => {
  const apiService = new ApiService();
  const tokenContext = useContext(TokenContext);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailVerified, setEmailVerified] = useState<boolean>(false);
  const navigate = useNavigate();
  const entityId = localStorage.getItem("entity_id");
  const emailId = localStorage.getItem("email");
  const [count, setCount] = useState<number>(30);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [resetEmailOtp, setResetEmailOtp] = useState<boolean>(false);
  const {
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      emailOtp: "",
    },
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const otpValue = watch("emailOtp");
  const isOtpComplete = otpValue?.length === 6;

  const closeModal = () => {
    navigate("/confirmpassword");
    setModalOpen(false);
  };
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (count > 0) {
      timer = setTimeout(() => setCount(count - 1), 1000);
    } else {
      setIsDisabled(false);
    }
    return () => clearTimeout(timer);
  }, [count]);
  useEffect(() => {
    if (emailVerified) {
      setModalOpen(true);
    }
  }, [emailVerified]);
  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    if (isModalOpen) {
      timer = setTimeout(() => {
        closeModal(); // auto-close modal after 5s
      }, 5000);
    }
    return () => clearTimeout(timer); // cleanup if modal closes before 5s
  }, [isModalOpen, closeModal]);

  const handleResend = () => {
    setCount(30);
    setValue("emailOtp", "");
    setResetEmailOtp(prev => !prev);
    setIsDisabled(true);
  };

  const reSendOTP = async () => {
    try {
      const newResponse: any = await apiService.postApi(
        `${AUTH_URL}/forgot/re-send/otp-route`,
        {
          entityId,
          emailId,
        }
      );
      handleResend();

    } catch (error) {
    }
  };

  const onSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      let newData = {
        ...data,
        mobileOtp: "123456",
        emailOtp: data.emailOtp,
        entityId: entityId,
      };
      // Simulate API call with a delay
      const resposne = await apiService.postApi(
        `${AUTH_URL}/forgot/verify/otp-route`,
        newData
      );
      console.log(resposne, "response");
      if (resposne.status === "200") {
        setModalOpen(true);
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOtpComplete = (otp: any) => {
    setValue("emailOtp", otp);
    handleSubmit(onSubmit)(otp);
  };

  return (
    <AuthContainer>
      <div className="flex w-full rounded-[21.25px] h-full bg-white font-poppins">
        <div className="w-full h-full">
          <div className="md:mx-[8rem] my-[6rem] ">
            <div className="h-[100px] w-[239px] bg-[#D9D9D9] flex items-center justify-center">
              logo
            </div>
            <br />
            <p className="font-[700] text-[20px] font-poppins leading-[41.33px] track-[1%]">
              Welcome aboard 👋
            </p>
            <p className="font-[400] font-poppins text-[16px] leading-[36.73px] track-[1%] text-[#313957]">
              Let's Get You Started
            </p>
            <br />
            <form onSubmit={handleSubmit(onSubmit)}>
              <p className=" ml-7 font-[600] text-[18px] font-poppins leading-[38px] track-[1%]">{emailVerified ? `Email ID Verified` : `Verify your Email ID`}</p>
              {emailVerified && (
                <div className="ml-2">
                  <SecureImage fileKey={verificationbadge} alt="Verified" />
                </div>
              )}
              <OtpInput
                length={6}
                onComplete={handleOtpComplete}
                errors={errors}
                // placeholder="*"
                disabled={isSubmitting || emailVerified}
                className="custom-otp-class"
                key={resetEmailOtp ? "email-reset" : "email"}
                value=""
              />
              <div className="mx-[20px]">
                <button
                  type="button"
                  onClick={reSendOTP}
                  disabled={count > 0 || emailVerified}
                  className={`
                    mt-4 w-full h-[50px] px-4 py-2 
    rounded-2xl text-white text-[16px] font-medium 
    bg-[#444FBD] 
    transition duration-300 
                    ${count > 0 || emailVerified
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:bg-[#3a45a0]"
                    }
                  `}
                >
                  {emailVerified ? (
                    "Email Verified Successfully"
                  ) : count > 0 ? (
                    <>
                      <span className="mr-2">
                        Resend Email OTP in {count}s
                      </span>
                      <svg
                        className="inline w-4 h-4 animate-spin text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        ></path>
                      </svg>
                    </>
                  ) : (
                    "Resend Email OTP"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <CustomModal
        isOpen={isModalOpen}
        content={
          <div className="flex flex-col items-center">
            <SecureImage fileKey={check} alt="check" className="mb-2" />
            <p className="text-[18px] font-[600] text-[#4B4B4B]">
              Email Verification Successful
            </p>
            <p className="text-base text-[#4B4B4B] mb-6 text-center">
              Your email has been verified successfully
            </p>
            <br />
            <button
              onClick={closeModal}
              className="bg-[#444FBD] rounded-[5px] h-[37px] w-[99px] text-white"
            >
              OK
            </button>
          </div>
        }
        onClose={closeModal}
      />
    </AuthContainer>
  );
};

export default OTPVerification;
